
import AddValue from "./components/AddValue";
import List from "./components/List";
function App() {
  return (
    <div className="App">
    <h1>Hello world</h1>
    <AddValue/>
    <List/>
    </div>
  );
}

export default App;
